import React, { useEffect, useRef, useState } from 'react';
import { useUserRole } from '@/hooks/useUserRole';

export function PerformanceMonitor() {
  const { isSuperAdmin } = useUserRole();
  const [latency, setLatency] = useState<number | null>(null);
  const [renderMs, setRenderMs] = useState<number | null>(null);
  const t0 = useRef<number>(performance.now());

  useEffect(() => {
    setRenderMs(Math.round(performance.now() - t0.current));
  }, []);

  // Optional: ping edge function to estimate latency
  useEffect(() => {
    let canceled = false;
    (async () => {
      try {
        const t1 = performance.now();
        // Try to ping the generate-report function with HEAD request
        await fetch('/api/ping', { method: 'HEAD' }).catch(() => {
          // Fallback to Supabase function if /api/ping doesn't exist
          return fetch('/functions/v1/generate-report', { method: 'HEAD' });
        });
        if (!canceled) setLatency(Math.round(performance.now() - t1));
      } catch {
        // Ignore errors - latency measurement is optional
      }
    })();
    return () => { canceled = true; };
  }, []);

  // Only show for SuperAdmins and if enabled in localStorage
  if (!isSuperAdmin || localStorage.getItem("perfMonitor") !== "on") {
    return null;
  }

  const color =
    latency == null ? "bg-zinc-500" :
    latency < 200 ? "bg-emerald-500" :
    latency < 500 ? "bg-amber-500" : "bg-rose-500";

  return (
    <div className="fixed bottom-2 right-2 z-[9999] rounded px-3 py-2 text-xs shadow-md bg-background/90 backdrop-blur border">
      <div className="flex items-center gap-2">
        <span className={`h-2 w-2 rounded-full ${color}`} />
        <span>DB/Edge: {latency ?? "—"} ms</span>
        <span className="mx-2">•</span>
        <span>Render: {renderMs ?? "—"} ms</span>
      </div>
    </div>
  );
}